import { useIsTablet } from 'src/hooks/use-is-mobile';
import { imageOptimize } from 'src/service/image';
import { useState, useEffect } from 'react';
import categories from 'src/configs/categories';
import { fetchExplore } from 'src/app/explore/service';
import Link from 'next/link';

const TribeDuoComponent = ({ data }: { data: any }) => {
  const isTablet = useIsTablet();

  if (data?.banner.length > 0) {
    return (
      <div>
        <div className={`${isTablet ? 'flex' : 'block'} overflow-auto`}>
          {data?.banner.length > 0 && <TribeDuo data={data?.banner} />}
        </div>
        {/* <SeeAll routeLink="/reppl" /> */}
      </div>
    );
  }
  return <></>;
};

const TribeDuo = ({ data }: { data: any }) => {
  const isMobile = useIsTablet();

  const [tribeList, setTribeList] = useState<any[]>([]);
  const [defList, setDefTribeList] = useState<any[]>([]);

  useEffect(() => {
    const tribeData = data?.map((d) => {
      if (categories.filter((e) => e.value === d.tribe_name).length > 0) {
        return {
          title: d.tribe_name,
          image_url: '',
          count: 0,
          isCategory: true,
        };
      }
      return {
        title: d.tribe_name,
        image_url: d.banner_image_url,
        count: 0,
        isCategory: false,
      };
    });
    setTribeList(tribeData);
    setDefTribeList(tribeData);
  }, []);

  const getDataList = (dataList) => {
    let listData = '';
    dataList.forEach((sid, sidx) => {
      if (sidx > 0) {
        listData += `&name=${sid.title}`;
      } else {
        listData += `name=${sid.title}`;
      }
    });
    return listData;
  };

  const mapCount = (defData, newData) => {
    defData.forEach((e) => {
      newData.forEach((s) => {
        if (s.name === e.title) {
          e.count = s.count;
        }
      });
    });
  };

  useEffect(() => {
    const getCategories = async () => {
      const newTribeList = [...tribeList];
      // const catData = newTribeList.filter((e) => e.isCategory);
      const tagData = newTribeList.filter((e) => !e.isCategory);
      const fetchedCat = await fetchExplore({
        type: 'category',
      });
      const fetchedTag = await fetchExplore({
        type: 'tag',
        data: getDataList(tagData),
      });
      mapCount(newTribeList, fetchedCat);
      mapCount(newTribeList, fetchedTag);
      setTribeList(newTribeList);
    };

    if (defList?.length > 0) {
      getCategories();
    }
  }, [defList]);

  return (
    <div
      style={{ maxWidth: `${isMobile ? '' : '63rem'}` }}
      className="text-gray-900 flex overflow-auto mx-auto py-6"
    >
      <div className="flex w-full mx-3 md:mx-0">
        <BannerCard
          data={tribeList[0]}
          index="tab0"
          css={`w-full ${isMobile ? 'mx-2.5' : 'mr-12'}`}
        />
        <BannerCard
          data={tribeList[1]}
          index="tab1"
          css={`w-full ${isMobile ? 'mx-2.5' : ''}`}
        />
      </div>
    </div>
  );
};

const BannerCard = ({
  data,
  index,
  css,
}: {
  data: any;
  index: string;
  css: string;
}) => {
  const isMobile = useIsTablet();

  const getBGImage = () => {
    if (categories.filter((e) => e.value === data?.title).length > 0) {
      return `url(/images/assets/categories/${data.title
        .replace(' & ', '')
        .replace(/\s/g, '')}.png`;
    }
    return `url(${imageOptimize(data?.image_url)})`;
  };

  const getPath = (dataPath) => {
    return dataPath?.replace(/ /g, '-');
  };

  return (
    <Link prefetch={false} href={`/agora/${getPath(data?.title)}`}>
      <div className={`cursor-pointer ${css}`}>
        <div
          style={{
            height: `${isMobile ? '183.94px' : '270px'}`,
            maxWidth: '482px',
            minWidth: '250px',
            backgroundImage: getBGImage(),
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundColor: '#00000005',
            backgroundBlendMode: 'multiply',
          }}
          className={`${index}-banner-box rounded-3xl overflow-hidden`}
        />
        <div
          className={`text-gray-900 font-medium text-sm px-5 ${
            isMobile ? 'py-0.5' : 'py-5'
          }`}
        >
          {data?.subtitle && <div>{data?.subtitle}</div>}
          <div
            className={`font-semibold text-xl md:text-2xl py-1 ${
              isMobile ? 'pb-2' : 'pb-3'
            }`}
          >
            {!data?.isCategory && '#'}
            {data?.title}
          </div>
          {data?.description && (
            <div className="text-gray-500 line-clamp-2">
              {data?.description}
            </div>
          )}
          {data?.count && (
            <div className="text-gray-900 text-sm md:text-base">
              <span className="font-semibold pr-1">{data?.count}</span>
              creations
            </div>
          )}
        </div>
      </div>
    </Link>
  );
};

export default TribeDuoComponent;
